import React from "react";
import { Link } from "react-router-dom";

// No partner is named here yet. When a client, operator or statistical office
// agrees to be named, replace the matching line with the name or logo.
const items = [
  {
    label: "Mobile network operators",
    detail: "Nordics and Baltics",
  },
  {
    label: "National statistical offices",
    detail: "In dialogue in 5 countries",
  },
  {
    label: "Case studies",
    detail: "Oslo, Arendal, Stavanger and Frogn",
    to: "/projects",
  },
  {
    label: "Industry events",
    detail: "MWC, Intertraffic, ITS Norway",
  },
];

const ValidationStrip = () => {
  return (
    <section
      id="validation"
      aria-label="Where Telcofy works today"
      className="py-12 bg-paper border-y border-paper-300"
    >
      <div className="max-w-7xl mx-auto px-6">
        <p className="text-center text-[11px] font-semibold uppercase tracking-widest text-ink-subtle mb-6">
          Where Telcofy works today
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {items.map(({ label, detail, to }) => (
            <div
              key={label}
              className="text-center md:text-left px-4 py-3 border-l-0 md:border-l border-paper-300 first:border-l-0"
            >
              <p className="font-display text-sm font-semibold text-ink leading-tight">
                {label}
              </p>
              {to ? (
                <Link
                  to={to}
                  className="inline-block text-xs text-brand-700 underline underline-offset-2 hover:text-brand-600 mt-1"
                >
                  {detail}
                </Link>
              ) : (
                <p className="text-xs text-ink-subtle mt-1">{detail}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValidationStrip;
